import cn from "classnames"
import { RenderBardWithComponents } from "components/Wysiwyg"
import { DynamicHeadline } from "../../DynamicHeadline"
import Image from "../../Image"
import { TeaserLink } from "../TeaserLinksItem"
import styles from "./TeaserLinksGridItem.module.scss"
import { ArrowRightIcon, ExternalLinkIcon } from "@radix-ui/react-icons"

const TeaserLinksGridItem = ({ teaser, className }) => {
  const {
    link_link: link,
    link_image: image,
    link_text: text,
    link_anchor: anchor,
    dynamic_headline: headline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    new_tab: newTab,
    icon,
    bottom_link_text,
  } = teaser

  const teaserLinkWrapperCN = cn(styles.teaserLinkWrapper, className, {
    [styles.withImage]: image,
  })

  const linkWithAnchor = anchor ? `${link || ""}#${anchor}` : link
  const bottomLinkText = bottom_link_text || "Mehr erfahren"

  const linkIcon = newTab ? (
    <ExternalLinkIcon className={styles.buttonIcon} />
  ) : (
    <ArrowRightIcon className={styles.buttonIcon} />
  )

  return (
    <TeaserLink
      className={teaserLinkWrapperCN}
      url={linkWithAnchor}
      openNewTab={newTab}
    >
      <div className={styles.inner}>
        <div className={styles.bg} aria-hidden>
          {image && (
            <>
              <Image
                src={image.permalink}
                alt={image.alt}
                className={styles.image}
                quality={100}
                style={{ objectPosition: image.focus_css }}
                sizes="(max-width: 1024px) 1920px, (max-width: 1280px) 828px, (max-width: 1720px) 768px, 1080px"
                fill
              />
              <div className={styles.gradient} />
            </>
          )}
        </div>
        <div className={styles.content}>
          <div className={styles.contentWrapper}>
            {icon && (
              <div className={styles.iconWrapper}>
                <Image
                  src={icon.permalink}
                  alt={icon.alt}
                  className={styles.icon}
                  width={icon.width}
                  height={icon.height}
                />
                <Image
                  src={icon.permalink}
                  alt={icon.alt}
                  className={styles.iconInWhite}
                  width={icon.width}
                  height={icon.height}
                  aria-hidden
                />
              </div>
            )}
            {headline && (
              <DynamicHeadline
                className={styles.headline}
                headlineType={headlineType.value}
                headlineAppearance={headlineAppearance.value}
              >
                {headline}
              </DynamicHeadline>
            )}
            {text && (
              <div className={styles.text}>
                <RenderBardWithComponents content={text} prefix="link_text_" />
              </div>
            )}
          </div>
          {linkWithAnchor && (
            <div className={styles.bottomLink}>
              <div className={styles.linkIndicator}>{linkIcon}</div>
              <div className={styles.fullLink}>
                <span>{bottomLinkText}</span> {linkIcon}
              </div>
            </div>
          )}
        </div>
      </div>
    </TeaserLink>
  )
}

export default TeaserLinksGridItem
